export const FULLSTORY_ELEMENTS = Object.freeze({
  landing: Object.freeze({
    navTrial: "Landing: Navigation Trial CTA",
    navLogin: "Landing: Navigation Login Button",
    heroTrial: "Landing: Hero Trial CTA",
    pricingTrial: "Landing: Pricing Trial CTA",
    pricingWatchDemo: "Landing: Pricing Watch Demo CTA",
    finalTrial: "Landing: Final Trial CTA",
  }),
  authentication: Object.freeze({
    signIn: "Authentication: Sign In Button",
    googleSignIn: "Authentication: Google Sign In Button",
    createAccount: "Authentication: Create Account Button",
    googleCreateAccount: "Authentication: Google Create Account Button",
    forgotPassword: "Authentication: Forgot Password Link",
    switchToLogin: "Authentication: Switch To Login Link",
    switchToRegister: "Authentication: Switch To Register Link",
  }),
  onboarding: Object.freeze({
    continueSetup: "Onboarding: Continue Setup Button",
    completeSetup: "Onboarding: Complete Setup Button",
    skipTour: "Onboarding: Skip Tour Button",
  }),
  billing: Object.freeze({
    selectMonthly: "Billing: Select Monthly Plan Button",
    selectAnnual: "Billing: Select Annual Plan Button",
    startAnnualSubscription: "Billing: Start Annual Subscription Button",
    startMonthlySubscription: "Billing: Start Monthly Subscription Button",
    manageSubscription: "Billing: Manage Subscription Button",
    resumeSubscription: "Billing: Resume Subscription Button",
    reactivateSubscription: "Billing: Reactivate Subscription Button",
    cancelSubscription: "Billing: Cancel Subscription Button",
    applyCoupon: "Billing: Apply Coupon Code Button",
    viewPlans: "Billing: View Plans Button",
    schoolLicensing: "Billing: School Licensing Button",
  }),
  preview: Object.freeze({
    activatePreview: "Preview: Activate 7-Day Back-to-School Preview Button",
    openApp: "Preview: Open Lesson Launchpad Button",
    pricingMonthly: "Preview: Monthly Pricing Button",
    pricingYearly: "Preview: Yearly Pricing Button",
    viewOffer: "Preview: View Back-to-School Preview Offer",
  }),
  teacherHub: Object.freeze({
    openClasses: "Teacher Hub: Open Classes Button",
    openSchedules: "Teacher Hub: Open Schedules Button",
    openAutomations: "Teacher Hub: Open Automations Button",
    openEvents: "Teacher Hub: Open Events Button",
    createClass: "Teacher Hub: Create Class Button",
    enterPresent: "Teacher Hub: Enter Present Button",
  }),
  classManager: Object.freeze({
    addClass: "Class Manager: Add Class Button",
    importClassList: "Class Manager: Import/Quick Add Button",
    editClass: "Class Manager: Edit Class Button",
    deleteClass: "Class Manager: Delete Class Button",
    openContentManager: "Class Manager: Open Content Manager Button",
    openScheduleCalendar: "Class Manager: Open Schedule Calendar Button",
    openClassStyles: "Class Manager: Open Class Styles Button",
  }),
  classEditor: Object.freeze({
    saveClass: "Class Editor: Save Class Button",
    cancelClass: "Class Editor: Cancel Button",
    confirmActiveDateChange: "Class Editor: Confirm Active Date Change Button",
  }),
  present: Object.freeze({
    addContentBox: "Present: Add Content Box Button",
    openContentManager: "Present: Open Content Manager Button",
    enterFullScreen: "Present: Enter Full Screen Button",
    exitFullScreen: "Present: Exit Full Screen Button",
    manageBoxes: "Present: Manage Boxes Button",
    createBoxStackFromManage: "Present: Create Box Stack From Manage Boxes Button",
    openClassStyles: "Present: Open Class Styles Button",
    saveClassStyles: "Present: Save Class Styles Button",
    showAnnouncement: "Present: Show Announcement Button",
    openWhiteboard: "Present: Open Whiteboard Button",
    startTimer: "Present: Start Timer Button",
    pauseTimer: "Present: Pause Timer Button",
    resetTimer: "Present: Reset Timer Button",
    startStopwatch: "Present: Start Stopwatch Button",
    resetStopwatch: "Present: Reset Stopwatch Button",
  }),
  contentManager: Object.freeze({
    addContentBox: "Content Manager: Add Content Box Button",
    addBoxStack: "Content Manager: Add Box Stack Button",
    saveContentBox: "Content Box Editor: Save Changes Button",
    duplicateContentBox: "Content Box Editor: Duplicate Button",
    deleteContentBox: "Content Box Editor: Delete Button",
    openAgendaEditor: "Content Box Editor: Open Agenda Editor Button",
    openResourcePicker: "Content Box Editor: Open Resource Picker Button",
    backToPresent: "Content Manager: Back To Present Button",
  }),
  scheduleManager: Object.freeze({
    createSchedule: "Schedule Manager: Create Schedule Button",
    editSchedule: "Schedule Manager: Edit Schedule Button",
    deleteSchedule: "Schedule Manager: Delete Schedule Button",
    saveSchedule: "Schedule Builder: Save Schedule Button",
    addScheduleDay: "Schedule Builder: Add Schedule Day Button",
    assignSchedule: "Schedule Calendar: Assign Schedule Button",
    saveCalendar: "Schedule Calendar: Save Calendar Button",
  }),
  automations: Object.freeze({
    createAutomation: "Automations: Create Automation Button",
    createCountdown: "Automations: Create Countdown Button",
    createReminder: "Automations: Create Reminder Button",
    createMusic: "Automations: Create Music Button",
    openBuilder: "Automations: Open Builder Button",
    deleteAutomation: "Automations: Delete Automation Button",
    previewAutomation: "Automations: Preview Automation Button",
    saveAutomation: "Automation Builder: Save Automation Button",
    deleteSequence: "Automation Builder: Delete Automation Button",
    addStep: "Automation Builder: Add Step Button",
    saveStep: "Automation Builder: Save Step Button",
    deleteStep: "Automation Builder: Delete Step Button",
    backToAutomations: "Automation Builder: Back To Automations Button",
  }),
  events: Object.freeze({
    addEvent: "Events Manager: Add Event Button",
    saveEvent: "Events Manager: Save Event Button",
    deleteEvent: "Events Manager: Delete Event Button",
    skipOccurrence: "Events Manager: Skip Occurrence Button",
    importEvents: "Events Manager: Import Events Button",
  }),
  settings: Object.freeze({
    manageSubscription: "Settings: Manage Subscription Button",
    saveSettings: "Settings: Save Settings Button",
    signOut: "Settings: Sign Out Button",
  }),
  helpCenter: Object.freeze({
    search: "Help Center: Search Input",
    joinOfficeHours: "Help Center: Join Office Hours Button",
    openLearningCenter: "Help Center: Open Learning Center Button",
    contactSupport: "Help Center: Contact Support Button",
  }),
  errorRecovery: Object.freeze({
    retry: "Error Recovery: Retry Button",
    reload: "Error Recovery: Reload Button",
    goHome: "Error Recovery: Go Home Button",
  }),
  liveOfficeHours: Object.freeze({
    join: "Live Office Hours: Join Button",
    leave: "Live Office Hours: Leave Button",
  }),
});
